"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShoppingPortalStore = exports.ShoppingPortalContainer = exports.ShoppingPortalSubscriber = exports.shoppingPortalStore = exports.SHOPPING_PORTAL_STORE_NAME = void 0;
const react_sweet_state_1 = require("react-sweet-state");
const actions_1 = require("./actions");
const state_1 = require("./state");
exports.SHOPPING_PORTAL_STORE_NAME = 'monera-shopping-portal-store';
exports.shoppingPortalStore = (0, react_sweet_state_1.createStore)({
    actions: actions_1.shoppingPortalActions,
    initialState: state_1.initialShoppingPortalState,
    name: exports.SHOPPING_PORTAL_STORE_NAME
});
exports.ShoppingPortalSubscriber = (0, react_sweet_state_1.createSubscriber)(exports.shoppingPortalStore);
exports.ShoppingPortalContainer = (0, react_sweet_state_1.createContainer)(exports.shoppingPortalStore, {
    onInit: () => ({ setState }, { initialState }) => setState(initialState !== null && initialState !== void 0 ? initialState : state_1.initialShoppingPortalState),
    onUpdate: () => ({ setState }, { initialState }) => setState(initialState !== null && initialState !== void 0 ? initialState : state_1.initialShoppingPortalState)
});
exports.useShoppingPortalStore = (0, react_sweet_state_1.createHook)(exports.shoppingPortalStore);
__exportStar(require("./selectors"), exports);
__exportStar(require("./types"), exports);
